import React, { useContext, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { UserContext } from '../UserContext';
import AuthLayout from './AuthLayout';

const ProtectedRoute = ({
  withLayout = true,
  requireAdminAccess = false,
  blockOrganizationMembers = false,
}) => {
  const { userId, isPlatformAdmin, organizationRole, mustChangePassword } =
    useContext(UserContext);
  const isOrganizationAdmin = organizationRole === 'ADMIN';
  const isRestrictedOrganizationMember =
    organizationRole === 'MEMBER' && !isPlatformAdmin;

  useEffect(() => {
    console.log('ProtectedRoute - Current userId:', userId);
    console.log('ProtectedRoute - localStorage userId:', localStorage.getItem('userId'));
  }, [userId]);

  // If there's no userId, redirect to login
  if (!userId) {
    console.log('ProtectedRoute - Redirecting to login due to no userId');
    return <Navigate to="/login" replace />;
  }

  // A temporary password is not a usable credential: hold the session on the
  // change-password screen before any protected page renders. Checked ahead of
  // the role gates so it cannot be sidestepped by aiming at a page the user
  // would be redirected away from anyway.
  if (mustChangePassword) {
    return <Navigate to="/change-password" replace />;
  }

  if (requireAdminAccess && !isPlatformAdmin && !isOrganizationAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (blockOrganizationMembers && isRestrictedOrganizationMember) {
    return <Navigate to="/dashboard" replace />;
  }

  return withLayout ? <AuthLayout /> : <Outlet />;
};

export default ProtectedRoute;
